import { useMediaQuery } from "react-responsive";

function Footer() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  const mobile = useMediaQuery({
    query: "(max-width : 1023px)",
  });

  return (
    <footer className="footer">
      <div className="inner">
        <div className="footer-top">
          <div>
            <h3 className="footer-heliosen">헬리오센(주)</h3>
            <p className="footer-full-heliosen">
              ©HELIOSEN. All rights reserved
            </p>
          </div>
          {pc && (
            <button
              className="footer-youtube-btn"
              onClick={() => window.open("https://youtube.com/@heliosen4024")}
            >
              <span className="footer-youtube-btn-title">회사 소개 영상</span>
              <span className="footer-youtube-btn-img"></span>
            </button>
          )}
        </div>
        <div>
          <ul className="footer-item">
            <li className="footer-list">
              <p className="footer-title">대표이사</p>
              <h4 className="footer-subtitle">이종훈</h4>
            </li>
            <li className="footer-list">
              <p className="footer-title">전화번호</p>
              <h4 className="footer-subtitle">+82) 031-697-0610</h4>
            </li>
            <li className="footer-list">
              <p className="footer-title">주소</p>
              {pc ? (
                <h4 className="footer-subtitle">
                  경기 성남시 분당구 판교역로 230 삼환하이펙스 B동 B101호
                </h4>
              ) : (
                <h4 className="footer-subtitle">
                  <span className="txt">
                  경기 성남시 분당구 판교역로 230
                  </span>
                  <span className="txt">삼환하이펙스 B동 B101호</span>
                </h4>
              )}
            </li>
            <li className="footer-list">
              <p className="footer-title">이메일</p>
              <h4 className="footer-subtitle">heliosen@heliosen.co.kr</h4>
            </li>
          </ul>
          {mobile && (
            <button
              className="footer-youtube-btn"
              onClick={() => window.open("https://youtube.com/@heliosen4024")}
            >
              <span className="footer-youtube-btn-title">회사 소개 영상</span>
              <span className="footer-youtube-btn-img"></span>
            </button>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
